import React, { Component } from 'react';
import './App.css';
import NavBar from './components/navBar/NavBar';
import DashboardPage from './pages/dashboardPage/DashboardPage';
import { PopupController } from './components/popupController/PopupController';
import ReportsPage from './pages/reportsPage/ReportsPage';
import Login from './pages/login/Login';
import { Route, Router, Switch } from 'react-router-dom';
import history from './history';
import UsersPage from './pages/usersPage/UsersPage';
import models from './model/models';
import mainAPI from './api/MainAPI';
import RecommendedReportsPage from './pages/recommendedReportsPage/RecommendedReportsPage';
import CustomReportsPage from './pages/customReportsPage/CustomReportsPage';
import DrugPage from './pages/drugPage/DrugPage';
import CustomReport from './pages/customReport/CustomReport';
import UnitListPage from './pages/unitListPage/UnitListPage';
import UnitDetailsPage from './pages/unitDetailsPage/UnitDetailsPage';
import SettingsPage from './pages/settingsPage/SettingsPage';
import GeneralSettingsPage from './pages/generalSettingsPage/GeneralSettingsPage';
import AvailableDrugsPage from './pages/availableDrugsPage/AvailableDrugsPage';
import NotificationsPage from './pages/notificationsPage/NotificationsPage';
import IntegrationsPage from './pages/integrationsPage/IntegrationsPage';
import SensorsPage from './pages/sensorsPage/SensorsPage';
import Toasts from './components/toasts/Toasts';
import toasts from './utils/toasts';
import UserDetailsPage from './pages/userDetailsPage/UserDetailsPage';
import SuperAdminSettingsPage from './pages/superAdminSettingsPage/SuperAdminSettingsPage';
import GroupUserListPage from './pages/groupUserListPage/GroupUserListPage';
import DrugDetailsPage from './pages/drugDetailsPage/DrugDetailsPage';
import DrugBoxDetailsPage from './pages/drugBoxDetailsPage/DrugBoxDetailsPage';
import DrugOrderFormDetailsPage from './pages/drugOrderFormDetailsPage/DrugOrderFormDetailsPage';
import CreateGroupPage from './pages/createGroupPage/CreateGroupPage';
import ActivityMapPage from './pages/activityMapPage/ActivityMapPage';
import LabelShippingPage from "./pages/labelShippingPage/LabelShippingPage";
import FormsPage from "./pages/formsPage/FormsPage";
import FormExportPage from "./pages/formExportPage/FormExportPage";
import BloodCommSettingsPage from "./pages/bloodCommSettingsPage/BloodCommSettingsPage";
import NewLabelRequestPage from "./pages/newLabelRequestPage/NewLabelRequestPage";
export const VERSION = '3.8.18';
class App extends Component {
	checkUrl = () => {
		const queryString = this.query_string();
		let hash = (window.location.hash || queryString.hash || '').replace('#', '');
		if (hash === 'set-storage') {
			localStorage.clear();
			const storage = JSON.parse(queryString.storage);
			for (let i in storage) {
				localStorage.setItem(i, storage[i]);
			}
			window.location.hash = '';
			window.location = '/'
		}
	};
	query_string = () => {
		let queryString = window.location.search;
		let query = {};
		let pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
		for (let i = 0; i < pairs.length; i++) {
			let pair = pairs[i].split('=');
			query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
		}
		return query;
	};
	componentDidMount = async () => {
		this.checkUrl();
		document.fonts.load('16px "Helvetica Neue"').then(() => {
			document.body.classList.remove('main-font-loading')
		});
		document.fonts.load('16px "untitled-font-1"').then(() => {
			document.body.classList.remove('icon-font-loading')
		});
		if (localStorage.token) {
			let user = await mainAPI.user.get();
			if (!user) return;
			if (user.role !== 'admin' && user.role !== 'super_admin') {
				toasts.show('You are not an admin. Download the LogRx app', 3000);
				delete localStorage.token;
				delete localStorage.user_group_id;
				delete localStorage.num_additional_groups;
				localStorage.clear();
				setTimeout(() => {
					window.location.reload();
				}, 1001);
				return;
			}
			models.user.setCurrent(user);
			for (let i in models) {
				models[i]._subscribeSockets();
			}
		}
	};

	render() {
    const classNames = ['App'];
    const adaAgencyIds = ['1655423163014', '1548633353696'];
    if(adaAgencyIds.includes(localStorage.user_group_id)){
      classNames.push('ada')
    }
		return (
			<div className={classNames.join(' ')}>
				<Toasts />
				<NavBar />
				<div className="pages">
					<Router history={history}>
						<Switch>
							<Route key={0} path="/" exact component={DashboardPage} />
							<Route key={1} path="/login" exact component={Login} />
							<Route key={2} path="/reports" exact component={ReportsPage} />
							<Route key={3} path="/reports/recommended" exact component={RecommendedReportsPage} />
							<Route key={4} path="/reports/custom" exact component={CustomReportsPage} />
							<Route key={5} path="/reports/:reportname" exact component={CustomReport} />
							<Route key={6} path="/reports/:reportname/:id" exact component={CustomReport} />
							<Route key={7} path="/users" exact component={UsersPage} />
							<Route key={8} path="/user/:id" exact component={UserDetailsPage} />
							<Route key={9} path="/drugs" exact component={DrugPage} />
							<Route key={10} path="/units" exact component={UnitListPage} />
							<Route key={27} path="/settings/general" exact component={GeneralSettingsPage} />
							<Route key={28} path="/settings/drugs" exact component={AvailableDrugsPage} />
							<Route key={29} path="/settings/notifications" exact component={NotificationsPage} />
							<Route key={30} path="/settings/integrations" exact component={IntegrationsPage} />
							<Route key={31} path="/settings/sensors" exact component={SensorsPage} />
							<Route key={31} path="/settings/bloodcomm" exact component={BloodCommSettingsPage} />
							<Route key={12} path="/super/admin/settings" exact component={SuperAdminSettingsPage} />
							<Route key={13} path="/group/users/:userGroupId" exact component={GroupUserListPage} />
							<Route key={14} path="/drugs" exact component={DrugPage} />
							<Route key={15} path="/units" exact component={UnitListPage} />
							<Route key={16} path="/settings" exact component={SettingsPage} />
							<Route key={17} path="/unit/:id" exact component={UnitDetailsPage} />
							<Route key={18} path="/drug/:id" exact component={DrugDetailsPage} />
							<Route key={19} path="/drug_box/:id" exact component={DrugBoxDetailsPage} />
							<Route key={27} path="/drug_order_form/:id" exact component={DrugOrderFormDetailsPage} />
							<Route key={32} path="/drug-order-form/:id" exact component={DrugOrderFormDetailsPage} />
							<Route key={21} path="/group/create" exact component={CreateGroupPage} />
							<Route key={22} path="/activity" exact component={ActivityMapPage} />
							<Route key={24} path="/super/admin/label-request/:id" exact component={LabelShippingPage} />
							<Route key={24} path="/forms" exact component={FormsPage} />
							<Route key={25} path="/forms/:id" exact component={FormExportPage} />
							<Route key={26} path="/new-label-request" exact component={NewLabelRequestPage} />
						</Switch>
					</Router>
				</div>
        <PopupController ref={(ref) => (window.popupController = ref)} />
      </div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx